import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../services/queryClient";
import { getToken } from "../../utils/getToken";

export const useDeleteDiscountMutation = () => {
  const token = getToken();

  return useMutation({
    mutationFn: (data: any) => {
      const payload = { ids: [data] };
      return axiosInstance
        .delete("/discounts", {
          data: payload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data);
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ["useGetDiscountQuery"] });
      message.success("Deleted");
    },
    onError: (error: any) => {
      message.error(
        error?.response?.data?.message || "Failed to delete discount"
      );
    },
  });
};
